module.exports = __webpack_public_path__ + "static/img/pic_title.3f86d6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/portal/pic_title.png
// module id = Dnod
// module chunks = 35